// {
//   "name": "iconic-hotspot-second.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-hotspot-second')) return;

  class IconicHotspotSecond extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const wraps = this.querySelectorAll('.iconic-stl-dot-wrap');
      const popovers = this.querySelectorAll('.iconic-stl-popover');
      const closes = this.querySelectorAll('.iconic-stl-popover-close');

      wraps.forEach((wrap, i) => {
        const dot = wrap.querySelector('.iconic-stl-dot');
        if (!dot) return;

        const pNode = popovers[i];
        if (pNode) {
          pNode._defaultSide = pNode.classList.contains('iconic-stl-popover--left') ? 'left' : 'right';
        }

        dot.addEventListener('click', () => {
          const popover = popovers[i];
          const isOpen = wrap.classList.contains('iconic-stl-dot-wrap--active');

          wraps.forEach(w => w.classList.remove('iconic-stl-dot-wrap--active'));
          popovers.forEach(p => {
            p.classList.remove('iconic-stl-popover--active');
            p.style.marginLeft = '';
            if (p._defaultSide === 'left') {
              p.classList.add('iconic-stl-popover--left');
              p.classList.remove('iconic-stl-popover--right');
            } else if (p._defaultSide === 'right') {
              p.classList.add('iconic-stl-popover--right');
              p.classList.remove('iconic-stl-popover--left');
            }
          });

          if (!isOpen && popover) {
            wrap.classList.add('iconic-stl-dot-wrap--active');
            popover.style.marginLeft = '';
            popover.classList.add('iconic-stl-popover--active');

            let rect = popover.getBoundingClientRect();
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            const PADDING = 24;

            if (viewportWidth >= 768) {
              let isOverflowRight = rect.right > viewportWidth - PADDING;
              let isOverflowLeft = rect.left < PADDING;
              
              if (isOverflowRight && popover.classList.contains('iconic-stl-popover--right')) {
                 popover.classList.remove('iconic-stl-popover--right');
                 popover.classList.add('iconic-stl-popover--left');
                 rect = popover.getBoundingClientRect();
                 if (rect.left < PADDING) {
                   popover.classList.remove('iconic-stl-popover--left');
                   popover.classList.add('iconic-stl-popover--right');
                   rect = popover.getBoundingClientRect();
                 }
              } else if (isOverflowLeft && popover.classList.contains('iconic-stl-popover--left')) {
                 popover.classList.remove('iconic-stl-popover--left');
                 popover.classList.add('iconic-stl-popover--right');
                 rect = popover.getBoundingClientRect();
                 if (rect.right > viewportWidth - PADDING) {
                   popover.classList.remove('iconic-stl-popover--right');
                   popover.classList.add('iconic-stl-popover--left');
                   rect = popover.getBoundingClientRect();
                 }
              }
            }

            let shiftLeft = 0;
            if (rect.right > viewportWidth - PADDING) {
              shiftLeft = (viewportWidth - PADDING) - rect.right;
            } else if (rect.left < PADDING) {
              shiftLeft = PADDING - rect.left;
            }

            if (shiftLeft !== 0) {
              popover.style.marginLeft = `${shiftLeft}px`;
            }
          }
        });
      });

      closes.forEach(btn => {
        btn.addEventListener('click', () => {
          const popover = btn.closest('.iconic-stl-popover');
          const wrap = btn.closest('.iconic-stl-dot-wrap');
          if (popover) {
            popover.classList.remove('iconic-stl-popover--active');
            popover.style.marginLeft = '';
            if (popover._defaultSide === 'left') {
              popover.classList.add('iconic-stl-popover--left');
              popover.classList.remove('iconic-stl-popover--right');
            } else if (popover._defaultSide === 'right') {
              popover.classList.add('iconic-stl-popover--right');
              popover.classList.remove('iconic-stl-popover--left');
            }
          }
          if (wrap) wrap.classList.remove('iconic-stl-dot-wrap--active');
        });
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          wraps.forEach(w => w.classList.remove('iconic-stl-dot-wrap--active'));
          popovers.forEach(p => {
            p.classList.remove('iconic-stl-popover--active');
            p.style.marginLeft = '';
            if (p._defaultSide === 'left') {
              p.classList.add('iconic-stl-popover--left');
              p.classList.remove('iconic-stl-popover--right');
            } else if (p._defaultSide === 'right') {
              p.classList.add('iconic-stl-popover--right');
              p.classList.remove('iconic-stl-popover--left');
            }
          });
        }
      });
    }
  }

  customElements.define('iconic-hotspot-second', IconicHotspotSecond);
})();
